import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaModuloNome = (): TabelaColuna => ({
  Chave: 'nomeModulo',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Nome Módulo</div>
})
